import React, { FunctionComponent } from 'react';
import Svg from '@justgiving/svg';
import { shareShortIcon } from '@justgiving/icons';

interface Props {
  className?: string;
}

export const ShareIcon: FunctionComponent<Props> = ({ className = '' }) => {
  return <Svg markup={shareShortIcon} className={className} />;
};
